import { onFabricCanvasScaleCallback } from '@/infrastructure/engine2d/FabricCallbacks';
import {
    onMouseWheelContextualMenu,
    onMoveContextualMenu,
    onSelectContextualMenu,
    onTextChangeContextualMenu,
} from '@/infrastructure/engine2d/events/contextualMenuCallbacks';
import type { BasicTransformEvent, Canvas, FabricObject } from 'fabric';

type TObjectModifiedCallback = (event: BasicTransformEvent & { target: FabricObject }) => void;

type TFabricSceneEventsServiceParams = {
    canvas: Canvas;
    objectMovingConstrain: TObjectModifiedCallback;
};

// Owns the on/off lifecycle for scene-level fabric events that don't
// belong to any specific overlay: object constraint on move + the
// contextual-menu bookkeeping. Overlay-specific listeners (mask
// opacity on selection) live in FabricPrintZoneEngine2D. Pointer input
// (pan / zoom / touch) lives in input/{Pan,Zoom,Touch}Controller.
class FabricSceneEventsService {
    private readonly _canvas: Canvas;
    private readonly _objectMovingConstrain: TObjectModifiedCallback;

    constructor(params: TFabricSceneEventsServiceParams) {
        this._canvas = params.canvas;
        this._objectMovingConstrain = params.objectMovingConstrain;
        this._attach();
    }

    dispose(): void {
        this._canvas.off('object:moving', this._objectMovingConstrain);

        this._canvas.off('object:moving', onMoveContextualMenu);
        this._canvas.off('object:scaling', onMoveContextualMenu);
        this._canvas.off('object:rotating', onMoveContextualMenu);

        this._canvas.off('selection:created', onSelectContextualMenu);
        this._canvas.off('selection:updated', onSelectContextualMenu);
        this._canvas.off('text:changed', onTextChangeContextualMenu);
        this._canvas.off('object:scaling', onFabricCanvasScaleCallback);
        this._canvas.off('mouse:wheel', onMouseWheelContextualMenu);
    }

    private _attach(): void {
        this._canvas.on('object:moving', this._objectMovingConstrain);

        this._canvas.on('object:moving', onMoveContextualMenu);
        this._canvas.on('object:scaling', onMoveContextualMenu);
        this._canvas.on('object:rotating', onMoveContextualMenu);

        this._canvas.on('selection:created', onSelectContextualMenu);
        this._canvas.on('selection:updated', onSelectContextualMenu);

        this._canvas.on('text:changed', onTextChangeContextualMenu);
        this._canvas.on('object:scaling', onFabricCanvasScaleCallback);
        this._canvas.on('mouse:wheel', onMouseWheelContextualMenu);
    }
}

export { FabricSceneEventsService };
